"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ENGAGEMENT_CADENCE_DAYS_AGO () {
        return ENGAGEMENT_CADENCE_DAYS_AGO;
    },
    get frequencyToQuestionCount () {
        return frequencyToQuestionCount;
    },
    get getAdditionalFeedbackQuestion () {
        return getAdditionalFeedbackQuestion;
    },
    get getAllQuestions () {
        return getAllQuestions;
    },
    get getFactorDescription () {
        return getFactorDescription;
    },
    get getNonNpsQuestions () {
        return getNonNpsQuestions;
    },
    get getNpsQuestion () {
        return getNpsQuestion;
    },
    get getQuestionById () {
        return getQuestionById;
    },
    get getQuestionsByFactor () {
        return getQuestionsByFactor;
    },
    get processCohortFactors () {
        return processCohortFactors;
    },
    get processCompanyFactors () {
        return processCompanyFactors;
    },
    get selectReminderCadence () {
        return selectReminderCadence;
    },
    get surveyTimes () {
        return surveyTimes;
    }
});
const _factorsjson = /*#__PURE__*/ _interop_require_default(require("./factors.json"));
const _questionsjson = /*#__PURE__*/ _interop_require_default(require("./questions.json"));
_export_star(require("./canSendReminders"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const enpsAdditionalFeedbackQuestion = {
    id: "eNPSAdditionalFeedback",
    factor: "eNPS",
    subfactor: null,
    question: "Can you share any additional details that led to your rating above?",
    scale: "text"
};
const getAllQuestions = ()=>{
    return _questionsjson.default;
};
const getNpsQuestion = ()=>{
    return _questionsjson.default.find((q)=>q.factor === "eNPS");
};
const getNonNpsQuestions = ()=>{
    return _questionsjson.default.filter((q)=>q.factor !== "eNPS" && q.scale !== "text");
};
const getAdditionalFeedbackQuestion = ()=>{
    return _questionsjson.default.find((q)=>q.id === "CWtqm");
};
const getQuestionById = (id)=>{
    if (id === "eNPSAdditionalFeedback") {
        return enpsAdditionalFeedbackQuestion;
    }
    return _questionsjson.default.find((q)=>q.id === id);
};
const getQuestionsByFactor = (factor)=>{
    return _questionsjson.default.filter((q)=>q.factor === factor);
};
const getFactorDescription = (factor)=>{
    return _factorsjson.default.find((f)=>f.name.toLowerCase() === factor.toLowerCase())?.description;
};
const frequencyToQuestionCount = (frequencyInDays)=>{
    if (frequencyInDays <= 21) {
        return 10;
    } else if (frequencyInDays <= 28) {
        return 15;
    } else if (frequencyInDays <= 91) {
        return 20;
    } else if (frequencyInDays <= 182) {
        return 25;
    } else {
        return 25;
    }
};
const surveyTimes = {
    morning: {
        hours: 9,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    },
    "mid-day": {
        hours: 12,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    },
    afternoon: {
        hours: 16,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    },
    evening: {
        hours: 19,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    }
};
const ENGAGEMENT_CADENCE_DAYS_AGO = [
    3,
    5,
    20
];
const selectReminderCadence = (surveyFrequency)=>{
    if (surveyFrequency < 91) {
        return ENGAGEMENT_CADENCE_DAYS_AGO.slice(0, 2);
    } else {
        return ENGAGEMENT_CADENCE_DAYS_AGO;
    }
};
const processCompanyFactors = async (companyFactorsData)=>{
    const companyFactors = await Promise.all(companyFactorsData.factors.map((factor)=>{
        const questions = getQuestionsByFactor(factor.factor);
        const factorDescription = getFactorDescription(factor.factor);
        return {
            factor: factor.factor,
            description: factorDescription,
            questions: questions.map((question)=>question.question),
            companyScore: factor.average
        };
    }));
    // Filter out null values
    return companyFactors.filter((factor)=>factor !== null);
};
const processCohortFactors = (cohortFactorsData, companyFactorsData)=>{
    // format factor diff as (+/-) value
    const getFormattedDiff = (diff)=>{
        if (diff > 0) {
            return `+${diff}`;
        }
        return `${diff}`;
    };
    const cohortFactors = cohortFactorsData.factorsLowestToHighest.filter((factor)=>factor.factor !== null && factor.average !== null).map((factor)=>{
        const companyFactorScore = companyFactorsData.factors.find((f)=>f.factor === factor.factor)?.average;
        return {
            factor: factor.factor,
            average: factor.average,
            diff: companyFactorScore && factor.average ? getFormattedDiff(factor.average - companyFactorScore) : null
        };
    });
    return cohortFactors;
};
